import { zetApi } from '@zet/network'

import { appendOneCode } from '../../utils/index'

export const checkReferralZetCode = async (value: string) => {
  try {
    if (!value) return true

    const res = await zetApi.post('/user/validate', {
      key: 'referralCode',
      value: appendOneCode(value),
    })

    if (res.data.isValid) {
      return true
    } else {
      return false
    }
  } catch (error) {
    return { message: "Referrer's zetcode is invalid" }
  }
}
